import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import NotFound from 'bundles/phoenix/components/NotFound';
import ReviewsApp from 'bundles/reviews/components/ReviewsApp';
import ReviewsPageDirector from 'bundles/reviews/components/ReviewsPageDirector';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';

const ReviewsAppWithUserExperienceHandler = (props: React.ComponentProps<typeof ReviewsApp> & object) => (
  <UnifiedUserExperienceHandler>
    <ReviewsApp {...props} />
  </UnifiedUserExperienceHandler>
);

export default (
  <Route path="/" component={ReviewsAppWithUserExperienceHandler}>
    <CourseraRoute
      handle={{
        tracking: {
          data: () => ({
            page: { type: 'course_reviews', segment: 'consumer' },
          }),
        },
      }}
      path="learn/:slug/reviews"
      component={ReviewsPageDirector}
    />
    <CourseraRoute
      handle={{
        tracking: {
          data: () => ({
            page: { type: 'project_reviews', segment: 'consumer' },
          }),
        },
      }}
      path="projects/:slug/reviews"
      component={ReviewsPageDirector}
    />
    <CourseraRoute
      handle={{
        tracking: {
          data: (params) => ({
            page: { type: 'course_reviews', segment: 'enterprise' },
            enterprise: {
              ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
            },
          }),
        },
      }}
      path="/programs/:programSlug/learn/:slug/reviews"
      component={ReviewsPageDirector}
    />
    <CourseraRoute
      handle={{
        tracking: {
          data: (params) => ({
            page: { type: 'project_reviews', segment: 'enterprise' },
            enterprise: {
              ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
            },
          }),
        },
      }}
      path="/programs/:programSlug/projects/:slug/reviews"
      component={ReviewsPageDirector}
    />
    <Route path="*" component={NotFound} />
  </Route>
);
